let widthPointPairMedialIndex = 0;
let widthPointPairLateralIndex = 0;
let selectedPointPairMedialIndex = 1;
let selectedPointPairLateralIndex = 1;
export function SetWidthPointPairMedialIndex(index) {
    widthPointPairMedialIndex = index;
}
export function GetWidthPointPairMedialIndex() {
    return widthPointPairMedialIndex;
}
export function SetWidthPointPairLateralIndex(index) {
    widthPointPairLateralIndex = index;
}
export function GetWidthPointPairLateralIndex() {
    return widthPointPairLateralIndex;
}
export function SetSelectedPointPairMedialIndex(index) {
    selectedPointPairMedialIndex = index;
}
export function GetSelectedPointPairMedialIndex() {
    return selectedPointPairMedialIndex;
}
export function SetSelectedPointPairLateralIndex(index) {
    selectedPointPairLateralIndex = index;
}
export function GetSelectedPointPairLateralIndex() {
    return selectedPointPairLateralIndex;
}
//# sourceMappingURL=border-width-parameters.js.map